import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Feather, ArrowRight } from "lucide-react";

export default function Articles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setItems(r.data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="fade-in">
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-primary/80 font-medium mb-3">Articles</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-stone-900">Words to encourage.</h1>
        <p className="mt-4 text-lg text-stone-700 max-w-2xl leading-relaxed">
          Reflections, devotionals, and teachings to help you walk with Christ.
        </p>
      </header>

      {loading ? (
        <div className="text-stone-500" data-testid="articles-loading">Loading articles…</div>
      ) : items.length === 0 ? (
        <div className="rounded-md border border-dashed border-stone-300 bg-white p-12 text-center" data-testid="articles-empty">
          <Feather className="h-10 w-10 text-stone-400 mx-auto mb-3" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl text-stone-900">Coming soon</h3>
          <p className="mt-2 text-stone-600 max-w-md mx-auto">Articles will appear here once published.</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="articles-grid">
          {items.map((a) => (
            <Link key={a.id} to={`/articles/${a.slug}`} data-testid={`article-card-${a.slug}`}
              className="group flex flex-col overflow-hidden rounded-md border border-stone-200 bg-white transition-all hover:-translate-y-1 hover:border-primary">
              {a.image_url && (
                <div className="relative h-44 overflow-hidden bg-stone-100">
                  <img src={a.image_url} alt={a.title} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
                </div>
              )}
              <div className="flex-1 p-6 flex flex-col">
                <div className="text-xs text-stone-500 mb-2">
                  {a.author ? <span>By {a.author} · </span> : null}
                  {new Date(a.created_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                </div>
                <h3 className="font-serif text-2xl text-stone-900 leading-tight">{a.title}</h3>
                {a.excerpt && <p className="mt-2 text-stone-600 leading-relaxed line-clamp-3 flex-1">{a.excerpt}</p>}
                <div className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary">
                  Read <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={1.5} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
